export default __webpack_public_path__ + "static/media/Donate.bfeb8606.jpg";